<div class="flex justify-between p-6 border-b border-[#E7EAF0]">
    <p class="text-[1.125rem] text-[#0A0A0A] font-semibold">Members</p>
    <button type="button" (click)="onCancel()">
        <img class="h-5 w-5" src="/assets/images/auth/cross.svg" alt="Close" />
    </button>
</div>

<div class="flex flex-col border border-t-0 border-[#E7EAF0] max-h-[600px] p-6 overflow-y-auto popup-scrollable-main">
    @if (isInitialLoading()) {
        <div>
            <app-people-skeleton></app-people-skeleton>
            <app-people-skeleton></app-people-skeleton>
            <app-people-skeleton></app-people-skeleton>
        </div>
    } @else if (membersData().length !== 0) {
        <div
            infiniteScroll
            [infiniteScrollContainer]="'.popup-scrollable-main'"
            [fromRoot]="true"
            [infiniteScrollDistance]="1"
            (scrolled)="onScroll()">
            <div class="flex flex-col gap-3">
                @for (item of membersData(); track $index) {
                    <app-people [people]="item" [isGroupMember]="true" (personClick)="onCancel()"></app-people>
                }
            </div>
        </div>
    } @else {
        <div class="text-center text-[#717182] py-10">No members found</div>
    }
</div>

<mat-dialog-actions>
    <button type="button" class="w-full border-button py-2 rounded-full" (click)="onCancel()">Close</button>
</mat-dialog-actions>
